const DATASET_TREND_BUTTON = {
  TREND_DIV_ID: 'DATA_TREND_DIV',
  TREND_HEIGHT: 300,
  DEFAULT_FIELD: 'id',
};

export default DATASET_TREND_BUTTON;
